import type { IconSvgObject } from './types';

const RepositoryIcon: IconSvgObject = [
  ["path", { d: "M18 19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2H6C4.34315 2 3 3.34315 3 5V16C3 17.6569 4.34315 19 6 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 10H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 6H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M9 22V15C9 14.4477 9.44772 14 10 14H14C14.5523 14 15 14.4477 15 15V22L12 20L9 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default RepositoryIcon;
